<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Customer Requests
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
      >
        <b-dropdown
          v-if="isMobile()"
          :text="currentTabTitle"
          variant="outline-primary"
        >
          <b-dropdown-item
            v-for="(tab, index) in visiblePageTabs"
            :key="index"
            @click="changeRoute(tab.param)"
          >
            {{ tab.title }} ({{ tab.count }})
          </b-dropdown-item>
        </b-dropdown>
        <b-tabs
          pills
          class="booking__content"
          :nav-class="[isMobile() ? 'd-none' : '']"
        >
          <!-- Tab: Account -->
          <b-tab
            v-if="$can('read', 'CustomerRequest')"
            :active="$route.params.type == 'profile-change'"
            lazy
            @click="changeRoute('profile-change')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Change Profile Requests <span class="rounded-number">{{ profileChangeRequestsCount }}</span></span>
            </template>
            <ProfileChangeRequests
              class="mt-2 pt-75"
            />
          </b-tab>
          <b-tab
            v-if="$can('read', 'TransferOwnership')"
            :active="$route.params.type == 'transfer-ownership'"
            lazy
            @click="changeRoute('transfer-ownership')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Transfer of Ownership Requests <span class="rounded-number">{{ toRequestsCount }}</span></span>
            </template>
            <TransferOwnershipRequests
              class="mt-2 pt-75"
            />
          </b-tab>
          <b-tab
            v-if="$can('read', 'ChangePurchaser')"
            :active="$route.params.type == 'change-purchaser'"
            lazy
            @click="changeRoute('change-purchaser')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Change of Purchaser Requests <span class="rounded-number">{{ cpRequestsCount }}</span></span>
            </template>
            <ChangePurchaserRequests
              class="mt-2 pt-75"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BTab, BTabs, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProfileChangeRequests from './profile-update/List.vue'
import TransferOwnershipRequests from './transfer-ownership/List.vue'
import ChangePurchaserRequests from './change-purchaser/List.vue'

export default {
  components: {
    BRow,
    BCol,
    BTab,
    BTabs,
    BDropdown,
    BDropdownItem,

    ProfileChangeRequests,
    TransferOwnershipRequests,
    ChangePurchaserRequests,
  },
  data() {
    return {
      profileChangeRequestsCount: 0,
      toRequestsCount: 0,
      cpRequestsCount: 0,
      currentTabTitle: 'Change Profile Requests',
      pageTabs: [
        {
          title: 'Change Profile Requests',
          param: 'profile-change',
          resource: 'CustomerRequest',
          count: 0,
        },
        {
          title: 'Transfer of Ownership Requests',
          param: 'transfer-ownership',
          resource: 'TransferOwnership',
          count: 0,
        },
        {
          title: 'Change of Purchaser Requests',
          param: 'change-purchaser',
          resource: 'ChangePurchaser',
          count: 0,
        },
      ],
    }
  },
  computed: {
    visiblePageTabs() {
      return this.pageTabs.filter(tab => this.$can('read', tab.resource))
    },
  },
  watch: {
    $route() {
      const param = this.$route.params.type
      const currentTab = this.pageTabs.find(o => o.param === param)
      if (currentTab) {
        this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
      }
    },
  },
  beforeMount() {
    this.redirectIfNoPermission()
    this.countBookings()
  },

  methods: {
    redirectIfNoPermission() {
      const currentTab = this.pageTabs.find(o => o.param === this.$route.params.type)
      if (!currentTab || !this.$can('read', currentTab.resource)) {
        const firstAllowed = this.visiblePageTabs[0]
        if (firstAllowed) {
          this.$router.replace({ params: { type: firstAllowed.param }, query: {} })
        }
      }
    },
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    countBookings() {
      this.$http.get('customer/customer/requests/count')
        .then(response => {
          this.profileChangeRequestsCount = response.data.profileChangeRequests
          this.toRequestsCount = response.data.toRequestsCount
          this.cpRequestsCount = response.data.cpRequestsCount
          this.pageTabs.forEach(element => {
            if (element.title === 'Change Profile Requests') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.profileChangeRequestsCount
            } else if (element.title === 'Transfer of Ownership Requests') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.toRequestsCount
            } else if (element.title === 'Change of Purchaser Requests') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.cpRequestsCount
            }
          })

          const param = this.$route.params.type

          const currentTab = this.pageTabs.find(o => o.param === param)
          if (currentTab) {
            this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style scoped>
  .rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
  }
</style>
